import type { RoleModel } from "./RoleModel";
import type { PermissionsCatalog, Role } from "./Role.typed";

export class RoleAdapter {
  constructor(private model: RoleModel) {}

  async getPermissionsCatalog(): Promise<PermissionsCatalog> {
    return this.model.getPermissionsCatalog();
  }

  async getRole(roleId: number): Promise<Role> {
    return this.model.getRole(roleId);
  }

  async createRole(payload: {
    name: string;
    permission_list: string[];
    company_id: number;
    is_employee?: boolean;
  }): Promise<void> {
    return this.model.createRole(payload);
  }

  async updateRole(
    roleId: number,
    payload: Partial<{ name: string; permission_list: string[]; is_employee: boolean }>,
  ): Promise<void> {
    return this.model.updateRole(roleId, payload);
  }

  async deleteRole(roleId: number): Promise<void> {
    return this.model.deleteRole(roleId);
  }
}
